// extracted by mini-css-extract-plugin
export var container = "PreconSupporterFooter-module--container--ec2f7";
export var copyright = "PreconSupporterFooter-module--copyright--d38bc";
export var footer = "PreconSupporterFooter-module--footer--29aba";
export var logo = "PreconSupporterFooter-module--logo--29cfc";
export var nav = "PreconSupporterFooter-module--nav--48c96";
export var navLink = "PreconSupporterFooter-module--navLink--e3a6c";
export var root = "PreconSupporterFooter-module--root--88e82";